import {
  Activity,
  AddressBook,
  Airplane,
  AirplaneTilt,
  AlignLeftSimple,
  AnchorSimple,
  Archive,
  ArrowBendDownLeft,
  ArrowCircleDown,
  ArrowClockwise,
  ArrowCounterClockwise,
  ArrowDown,
  ArrowFatLineRight,
  ArrowLeft,
  ArrowLineDown,
  ArrowLineLeft,
  ArrowLineRight,
  ArrowLineUp,
  ArrowRight,
  ArrowSquareIn,
  ArrowSquareOut,
  ArrowUUpLeft,
  ArrowUp,
  ArrowUpRight,
  ArrowsClockwise,
  ArrowsCounterClockwise,
  ArrowsDownUp,
  ArrowsIn,
  ArrowsInLineHorizontal,
  ArrowsInSimple,
  ArrowsLeftRight,
  ArrowsOut,
  ArrowsOutLineHorizontal,
  ArrowsOutSimple,
  At,
  Bell,
  BellRinging,
  BellSimple,
  BellSimpleSlash,
  BellSlash,
  Book,
  BookOpen,
  BookmarkSimple,
  Books,
  Briefcase,
  Broadcast,
  Browser,
  Browsers,
  Buildings,
  Cake,
  Calendar,
  CalendarBlank,
  CalendarCheck,
  Camera,
  CameraSlash,
  Car,
  Cards,
  CaretCircleDown,
  CaretDown,
  CaretLeft,
  CaretRight,
  CaretUp,
  ChalkboardTeacher,
  ChartBar,
  ChartLineUp,
  ChartPie,
  Chat,
  ChatCenteredText,
  ChatCircle,
  ChatCircleText,
  ChatText,
  ChatsCircle,
  Check,
  CheckCircle,
  CheckSquare,
  Circle,
  CircleNotch,
  CircleWavyCheck,
  CircleWavyWarning,
  Clipboard,
  ClipboardText,
  Clock,
  ClockAfternoon,
  ClockClockwise,
  ClockCounterClockwise,
  Cloud,
  CloudArrowUp,
  CloudCheck,
  Code,
  Coins,
  Columns,
  Copy,
  CopySimple,
  Crop,
  Crown,
  CurrencyDollar,
  Desktop,
  DeviceMobile,
  DeviceMobileCamera,
  DotsSixVertical,
  DotsThree,
  DotsThreeOutline,
  DotsThreeOutlineVertical,
  Download,
  DownloadSimple,
  Envelope,
  EnvelopeOpen,
  EnvelopeSimple,
  Export,
  Eye,
  EyeSlash,
  Eyedropper,
  File,
  FileArrowUp,
  FileDoc,
  FileHtml,
  FilePdf,
  FilePlus,
  FileText,
  FileX,
  Files,
  Fire,
  Flag,
  FloppyDisk,
  FolderSimple,
  FolderSimplePlus,
  Folders,
  Funnel,
  FunnelSimple,
  Gear,
  GenderIntersex,
  GitBranch,
  GitMerge,
  Globe,
  GlobeHemisphereWest,
  GlobeSimple,
  Gradient,
  GraduationCap,
  GridFour,
  Hand,
  HandPointing,
  HandWaving,
  Handshake,
  HardDrives,
  Hash,
  Heart,
  HighlighterCircle,
  House,
  HouseLine,
  IdentificationCard,
  Image,
  ImageSquare,
  Info,
  Kanban,
  Key,
  Layout,
  Lightbulb,
  LightbulbFilament,
  Lightning,
  Link,
  LinkBreak,
  LinkSimple,
  LinkedinLogo,
  List,
  ListBullets,
  ListChecks,
  ListDashes,
  ListNumbers,
  ListPlus,
  Lock,
  LockSimple,
  MagicWand,
  Magnet,
  MagnifyingGlass,
  MapPin,
  Medal,
  Megaphone,
  MegaphoneSimple,
  Microphone,
  Minus,
  MinusCircle,
  Money,
  Monitor,
  NavigationArrow,
  Newspaper,
  Note,
  NotePencil,
  Notepad,
  PaintBrush,
  PaintBrushBroad,
  Palette,
  PaperPlaneTilt,
  Paperclip,
  PauseCircle,
  PenNib,
  Pencil,
  PencilLine,
  PencilSimple,
  PencilSimpleLine,
  Phone,
  PlayCircle,
  Plus,
  PlusCircle,
  Printer,
  Prohibit,
  PushPin,
  PuzzlePiece,
  Question,
  Repeat,
  Rows,
  ShareNetwork,
  Shield,
  ShieldCheck,
  ShieldSlash,
  Sidebar,
  SignIn,
  SignOut,
  Sliders,
  SlidersHorizontal,
  Smiley,
  SortAscending,
  Sparkle,
  SquareHalf,
  SquaresFour,
  Stack,
  Star,
  Storefront,
  Suitcase,
  Swap,
  Table,
  Tag,
  TagChevron,
  Target,
  TelevisionSimple,
  TextAa,
  TextAlignCenter,
  TextAlignLeft,
  TextBolder,
  TextHOne,
  TextHThree,
  TextHTwo,
  TextItalic,
  TextStrikethrough,
  TextT,
  TextUnderline,
  Timer,
  ToggleLeft,
  Translate,
  Trash,
  TrendUp,
  UploadSimple,
  User,
  UserCircle,
  UserCircleGear,
  UserCirclePlus,
  UserGear,
  UserList,
  UserMinus,
  UserPlus,
  UserRectangle,
  UserSquare,
  UserSwitch,
  Users,
  UsersThree,
  Wallet,
  Warning,
  WarningCircle,
  Wheelchair,
  WifiX,
  X,
  XCircle,
} from 'phosphor-react';

export const PHOSPHOR_ICONS = {
  Activity,
  AddressBook,
  Airplane,
  AirplaneTilt,
  AlignLeftSimple,
  AnchorSimple,
  Archive,
  ArrowBendDownLeft,
  ArrowCircleDown,
  ArrowClockwise,
  ArrowCounterClockwise,
  ArrowDown,
  ArrowFatLineRight,
  ArrowLeft,
  ArrowLineDown,
  ArrowLineLeft,
  ArrowLineRight,
  ArrowLineUp,
  ArrowRight,
  ArrowSquareIn,
  ArrowSquareOut,
  ArrowUUpLeft,
  ArrowUp,
  ArrowUpRight,
  ArrowsClockwise,
  ArrowsCounterClockwise,
  ArrowsDownUp,
  ArrowsIn,
  ArrowsInLineHorizontal,
  ArrowsInSimple,
  ArrowsLeftRight,
  ArrowsOut,
  ArrowsOutLineHorizontal,
  ArrowsOutSimple,
  At,
  Bell,
  BellRinging,
  BellSimple,
  BellSimpleSlash,
  BellSlash,
  Book,
  BookOpen,
  BookmarkSimple,
  Books,
  Briefcase,
  Broadcast,
  Browser,
  Browsers,
  Buildings,
  Cake,
  Calendar,
  CalendarBlank,
  CalendarCheck,
  Camera,
  CameraSlash,
  Car,
  Cards,
  CaretCircleDown,
  CaretDown,
  CaretLeft,
  CaretRight,
  CaretUp,
  ChalkboardTeacher,
  ChartBar,
  ChartLineUp,
  ChartPie,
  Chat,
  ChatCenteredText,
  ChatCircle,
  ChatCircleText,
  ChatText,
  ChatsCircle,
  Check,
  CheckCircle,
  CheckSquare,
  Circle,
  CircleNotch,
  CircleWavyCheck,
  CircleWavyWarning,
  Clipboard,
  ClipboardText,
  Clock,
  ClockAfternoon,
  ClockClockwise,
  ClockCounterClockwise,
  Cloud,
  CloudArrowUp,
  CloudCheck,
  Code,
  Coins,
  Columns,
  Copy,
  CopySimple,
  Crop,
  Crown,
  CurrencyDollar,
  Desktop,
  DeviceMobile,
  DeviceMobileCamera,
  DotsSixVertical,
  DotsThree,
  DotsThreeOutline,
  DotsThreeOutlineVertical,
  Download,
  DownloadSimple,
  Envelope,
  EnvelopeOpen,
  EnvelopeSimple,
  Export,
  Eye,
  EyeSlash,
  Eyedropper,
  File,
  FileArrowUp,
  FileDoc,
  FileHtml,
  FilePdf,
  FilePlus,
  FileText,
  FileX,
  Files,
  Fire,
  Flag,
  FloppyDisk,
  FolderSimple,
  FolderSimplePlus,
  Folders,
  Funnel,
  FunnelSimple,
  Gear,
  GenderIntersex,
  GitBranch,
  GitMerge,
  Globe,
  GlobeHemisphereWest,
  GlobeSimple,
  Gradient,
  GraduationCap,
  GridFour,
  Hand,
  HandPointing,
  HandWaving,
  Handshake,
  HardDrives,
  Hash,
  Heart,
  HighlighterCircle,
  House,
  HouseLine,
  IdentificationCard,
  Image,
  ImageSquare,
  Info,
  Kanban,
  Key,
  Layout,
  Lightbulb,
  LightbulbFilament,
  Lightning,
  Link,
  LinkBreak,
  LinkSimple,
  LinkedinLogo,
  List,
  ListBullets,
  ListChecks,
  ListDashes,
  ListNumbers,
  ListPlus,
  Lock,
  LockSimple,
  MagicWand,
  Magnet,
  MagnifyingGlass,
  MapPin,
  Medal,
  Megaphone,
  MegaphoneSimple,
  Microphone,
  Minus,
  MinusCircle,
  Money,
  Monitor,
  NavigationArrow,
  Newspaper,
  Note,
  NotePencil,
  Notepad,
  PaintBrush,
  PaintBrushBroad,
  Palette,
  PaperPlaneTilt,
  Paperclip,
  PauseCircle,
  PenNib,
  Pencil,
  PencilLine,
  PencilSimple,
  PencilSimpleLine,
  Phone,
  PlayCircle,
  Plus,
  PlusCircle,
  Printer,
  Prohibit,
  PushPin,
  PuzzlePiece,
  Question,
  Repeat,
  Rows,
  ShareNetwork,
  Shield,
  ShieldCheck,
  ShieldSlash,
  Sidebar,
  SignIn,
  SignOut,
  Sliders,
  SlidersHorizontal,
  Smiley,
  SortAscending,
  Sparkle,
  SquareHalf,
  SquaresFour,
  Stack,
  Star,
  Storefront,
  Suitcase,
  Swap,
  Table,
  Tag,
  TagChevron,
  Target,
  TelevisionSimple,
  TextAa,
  TextAlignCenter,
  TextAlignLeft,
  TextBolder,
  TextHOne,
  TextHThree,
  TextHTwo,
  TextItalic,
  TextStrikethrough,
  TextT,
  TextUnderline,
  Timer,
  ToggleLeft,
  Translate,
  Trash,
  TrendUp,
  UploadSimple,
  User,
  UserCircle,
  UserCircleGear,
  UserCirclePlus,
  UserGear,
  UserList,
  UserMinus,
  UserPlus,
  UserRectangle,
  UserSquare,
  UserSwitch,
  Users,
  UsersThree,
  Wallet,
  Warning,
  WarningCircle,
  Wheelchair,
  WifiX,
  X,
  XCircle,
};
